import { c as _c } from "react/compiler-runtime";
import { PropsWithClassNameWithChildren } from "@/types/ui";
import { IconArrowUpRight } from "@tabler/icons-react";
import type { VariantProps } from "class-variance-authority";
import React from "react";
import { LinkProps } from "next/link";
import { ExternalLink } from "@components/common/external-link";
import { Badge, badgeVariants } from "@components/ui/badge";
import { cn } from "@lib/utils";

/**
 * Component that renders a badge-styled external link with an icon.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} [props.className] - Additional CSS classes for styling the external link.
 * @param {string} [props.variant] - Variant type for the badge. Defaults to "secondary".
 * @param {React.ReactNode} props.children - Content to be displayed within the link.
 * @returns {JSX.Element} A badge-wrapped external link styled according to the provided props.
 */
export const BadgeExternalLink = t0 => {
  const $ = _c(13);
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = variant;
  } else {
    className = $[1];
    props = $[2];
    variant = $[3];
  }
  const t1 = variant ?? "secondary";
  let t2;
  if ($[4] !== className) {
    t2 = cn("items-center no-underline", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconArrowUpRight />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t2) {
    t4 = <ExternalLink {...props} className={t2}>{props.children}{t3}</ExternalLink>;
    $[7] = props;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <Badge asChild={true} variant={t1} className="border-1 !border-transparent">{t4}</Badge>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};